<template>

    <div class="modal__overlay">

        <div class="modal-trip">

            <h4>{{ $t('trip.EDIT_PRACTICE_WITH_STUDENTS') }}</h4>

            <div class="content-for">
                <span :class="{'--selected' : contentFor == 'teacher'}" @click="contentFor = 'teacher'">{{$t('finalPractice.TEACHER_TITLE')}}</span>
                <span :class="{'--selected' : contentFor == 'student'}" @click="contentFor = 'student'">{{$t('finalPractice.STUDENT_TITLE')}}</span>
            </div>

            <div v-show="contentFor == 'teacher'">
                <TinyMCE 
                    :content="contents.own"
                    ref="tinyEditorTripTeacher"
                    id="tinyEditorTripTeacher"

                />
            </div>

            <div v-show="contentFor == 'student'">
                <TinyMCE
                    :content="contents.shared"
                    ref="tinyEditorTripStudent"
                    id="tinyEditorTripStudent"
                />
            </div>

            <div class="modal__buttons">
                <button class="cancel" @click.stop="emit('close')">{{ $t('global.CANCEL') }}</button>
                <button class="confirm" @click.stop="save()" 
                    :disabled="saving">
                    {{ $t('global.SAVE') }}<i class="material-icons">arrow_forward</i></button>
            </div>

        </div>

    </div>

</template>

<script setup>
import { defineProps, defineEmits, ref } from 'vue';
import { useStore } from 'vuex';
import TinyMCE from '@/components/TinyMCE.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const store = useStore();
const props = defineProps({
    content: Object
});
const emit = defineEmits(['close','reload']);

const contentFor = ref('teacher')
const tinyEditorTripTeacher = ref(null);
const tinyEditorTripStudent = ref(null);
const saving = ref(false);


const obtainContent = (tag, text) => {
    let open = `[BEGIN_${tag}]`;
    let close = `[END_${tag}]`;
    let begin = text.indexOf(open) + open.length;
    let end = text.indexOf(close);

    if (begin !== -1 && end !== -1) {
        return text.substring(begin, end);
    } else {
        return null; // La etiqueta no fue encontrada
    }
}

const contents = ref({
    own: obtainContent('OWN', props.content.data.Data) || '',
    ownBtn: obtainContent('OWN_BOTON', props.content.data.Data) || '',
    shared: obtainContent('SHARED', props.content.data.Data) || '',
    sharedBtn: obtainContent('SHARED_BOTON', props.content.data.Data) || '',
})

const save = async()=> {
    let own = `[BEGIN_OWN]${tinyEditorTripTeacher.value.editorInstance.getContent()}[END_OWN]`;
    let ownButton = `[BEGIN_OWN_BOTON]${contents.value.ownBtn}[END_OWN_BOTON]`;
    let shared = `[BEGIN_SHARED]${tinyEditorTripStudent.value.editorInstance.getContent()}[END_SHARED]`;
    let sharedButton = `[BEGIN_SHARED_BOTON]${contents.value.sharedBtn}[END_SHARED_BOTON]`;
    let newData = `<section style="display: flex; flex-direction: column; gap: 24px; font-family: 'Open Sans';">${own}${ownButton}${shared}${sharedButton}</section>`;
    saving.value = true;
    let model = props.content;
    model.data = {
        Data: newData
    }
    try {
        await store.dispatch('contentEditor_editContent', model)
        emit('reload');        
    } catch (error) {
        console.log(error)
        store.dispatch('notifications_create', { text: t('trip.ERROR_SAVING_CONTENT') });
    } finally {
        saving.value = false;
    }
}

</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
@import './commonStyles.scss';


.modal-trip{
    @include componentModal;
    h4{
        margin-bottom: 24px;
    }
    .content-for{
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        gap: 22px;
        span{
            font-size: 14px;
            font-weight: 600;
            padding: 8px 24px 8px 8px;
            margin: 0 6px;
            cursor: pointer;
            &.--selected{
                color: $green;
                border-bottom: 3px solid $green;
            }
        }
    }

}

</style>